import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import "./ProductGallery.css";

export default function ProductGallery({images}) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [mainSwiper, setMainSwiper] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="product-gallery">
      {/* Top Main Image */}
      <Swiper
        spaceBetween={10}
        onSwiper={setMainSwiper}
        onSlideChange={handleSlideChange}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Navigation, Thumbs]}
        className="main-swiper"
      >
        {images && images.map((img, index) => (
          <SwiperSlide key={index}>
            <img src={img.image} alt={`Product ${index + 1}`} className="main-image" />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Bottom Thumbnail Swiper with custom arrows */}
      <div className="thumbs-container">
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={5}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="thumb-swiper"
          breakpoints={{
            0: { slidesPerView: 3 },
            576: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            992: { slidesPerView: 5 },
          }}
        >
          {images && images.map((img, index) => (
            <SwiperSlide key={index}>
              <img src={img.image} alt={`Thumbnail ${index + 1}`} className="thumbnail" />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom outside navigation buttons */}
        <div
          className={`swiper-button-prev-custom ${isBeginning ? "disabled" : ""}`}
          onClick={() => mainSwiper?.slidePrev()}
        >
          &#10094;
        </div>
        <div
          className={`swiper-button-next-custom ${isEnd ? "disabled" : ""}`}
          onClick={() => mainSwiper?.slideNext()}
        >
          &#10095;
        </div>
      </div>
    </div>
  );
}
